import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_PREFIX, BASE_URL } from '@CONSTANTS/API.constant';
import { Country } from '@INTERFACES/api/countries';
import userRepository from '@REPOSITORIES/local-repository/user-repository';

type Id = number | undefined;

type GetAllParams = {
    region: Id;
    area: Id;
};

export const countryApi = createApi({
    reducerPath: 'country-api',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL + API_PREFIX,
        prepareHeaders: (headers) => {
            const token = userRepository.getData();

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAll: builder.query<Country[], GetAllParams>({
            query: (params: GetAllParams) => ({
                url: '/countries/',
                params: {
                    region: params.region,
                    areas: params.area,
                },
            }),
            transformResponse: (raw: Country[]) => raw.sort((a, b) => (a.name > b.name ? 1 : -1)),
        }),
        getAllCountries: builder.query<Country[], void>({
            query: () => ({
                url: '/countries/',
            }),
            transformResponse: (raw: Country[]) => raw.sort((a, b) => (a.name > b.name ? 1 : -1)),
        }),
    }),
});

export const {
    
    useGetAllCountriesQuery,
} = countryApi;
